import { $vfm } from 'vue-final-modal';

const defaultParams =
    {
        title: '系統提示',
        content: '系統忙碌中，請稍後再試',
        confirmButton: '確認',
        cancelButton: null,
        closeicon: true,
    };

export function openPopup(param, fn) {
    if (typeof param === 'string' && param) {
        param = { content: param };
    }
    const params = {
        ...defaultParams, ...param,
    };

    $vfm.show({
        component: 'DialogBase',
        params: params,
        on: {
            confirm() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
                if (params.confirmFunction) {
                    params.confirmFunction();
                }
            },
            closed() {
                $vfm.hide('DialogBase');
                if (fn) {
                    fn();
                }
            },
        },
    });
};

export function openPopupCatchMessage(err) {
    if (err.data?.details && err.data?.details?.length > 0) {
        openPopup((err?.data?.errorMessage ? err.data.errorMessage + '<br>' : '') + joinErrorDetails(err));
    } else {
        openPopup(err?.data?.errorMessage);
    }
};

export function openPopupCatch(param) {
    const err = param.error;
    const errorMessage = err?.data?.details && err?.data?.details?.length > 0 ? (err?.data?.errorMessage ? `${err.data.errorMessage}<br>` : '') + joinErrorDetails(err) : err?.data?.errorMessage;
    delete param.error;
    openPopup({
        ...param,
        content: errorMessage,
    });
};

export function joinErrorDetails(err) {
    return err.data.details.map(e => {
        return e.field ? `${e.field}: ${e.errorMessage}` : e.errorMessage;
    }).join('<br>');
};

export function clearDetailsField(err) {
    if (err?.data?.details) {
        err.data.details.forEach(e => {
            e.field = '';
        });
    }
};
